import React, { useEffect, useState } from 'react'
import Template from './../../components/Template'

const AmendPage = ({ history, match: { params: { id } } }) => {
  const [template, setTemplate] = useState(null)
  const [customerId, setCustomerId] = useState(null)

  useEffect(() => {
    fetch(`/rest/v2/order/${id}/amend`, {
      credentials: 'same-origin',
      method: 'GET',
    })
      .then((response) => response.json())
      .then(({ success, data, errors }) => {
        if (errors) {
          return window.alert(errors.join(', '))
        }

        setTemplate(data.template)
        setCustomerId(data.customerId)
      })
      .catch((error) => window.alert(error))
  }, [id])

  const onUpserted = (promise) => {
    promise.then((result) => {
      // Success
    })
  }

  return (
    <Template
      template={template}
      onUpserted={onUpserted}
      customerId={customerId}
    />
  )
}

export default AmendPage
